import { useState, useEffect } from "react";
import { Grid, Box, MenuItem } from '@mui/material';
import { TextField } from '@mui/material';
import MainCard from './MainCard';
import { gridSpacing } from '../../store/constant';
import axios from "../../components/axios";
import { useNavigate, useParams } from 'react-router-dom';


const ModifyFileLimitForm = () => {
    const navigate = useNavigate();
    const { uuid } = useParams();

    const fileDirections = [
      {
        value: 'u',
        label: 'Upload',
      },
      {
        value: 'd',
        label: 'Download',
      },
    ];

    const styleButton = {
        marginTop: "40px",
        backgroundColor: "#406599",
        color: "#fff",
        border: 0,
        borderRadius: "5px",
        boxSizing: "border-box",
        width: "120px",
        padding: "15px",
        fontSize: "18px",
        fontFamily: '"Roboto", "sans-serif"',
      };

    const [hardware, setHardware] = useState("");
    const [userAgent, setUserAgent] = useState("");
    const [fileDirection, setFileDirection] = useState('');
    const [trigger, setTrigger] = useState('');
    const [bucketName, setBucketName] = useState('');
    const handleBucketName = (event) => {
        setBucketName(event.target.value);
    };

    const [filePrefix, setFilePrefix] = useState('');
    const handleFilePrefix = (event) => {
        setFilePrefix(event.target.value);
    };

    const [limitIP, setLimitIP] = useState('');
    const handleLimitIP = (event) => {
        setLimitIP(event.target.value);
    };

    useEffect(() => {
      const getFileLimitInfo = async () => {
        try {
            var input_data = JSON.stringify({ id: uuid });
            const response = await axios.post("/peloton/v1/automation/limit-info", input_data, { withCredentials: true});
            if (response.data.message === "success"){
              setHardware(response.data.limit.hardware)
              setUserAgent(response.data.limit.user_agent)
              setBucketName(response.data.limit.bucket)
              setFilePrefix(response.data.limit.prefix)
              setTrigger(response.data.limit.trigger)
              setLimitIP(response.data.limit.ip_list)
              if (response.data.limit.direction === "upload"){
                setFileDirection('u');
              }else{
                setFileDirection('d');
              }
            }
        } catch (error) {
            if (error.response.status !== null){
                if (error.response.status === 401){
                    alert(error.response.data.message);
                    navigate("/");
                }else{
                    console.log('error.response.status: ', error.response.status)
                    console.log('error.response.message: ', error.response.data.message)
                }
            }else{
                console.log(error);
            }
        }
    };
    getFileLimitInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ uuid ]);

    const handleEditUser = async () => {
        var input_data = JSON.stringify({ uuid: uuid, hardware: hardware, user_agent: userAgent, 
          direction:fileDirection, bucket: bucketName, prefix: filePrefix, trigger:trigger, limit_ip: limitIP});

        axios.post("/peloton/v1/automation/modify-limit",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
              navigate("/file-limit");
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else{
                console.log('error.response.status: ', err.response.status)
                console.log('error.response.message: ', err.response.data.message)
                alert(err.response.data.message)
            }
          }
        })
    }

    return (
    <MainCard title="Edit File Limit">
        <Box sx={{ maxWidth: '100%'}}>
        <Grid container spacing={gridSpacing} justifyContent="center" rowSpacing={gridSpacing} columnSpacing={gridSpacing}>
        <Grid item xs={6}>
        <TextField
              disabled
              required
              fullWidth
              id="limit-hardware"
              label="hardware"
              value={hardware}
              variant="filled"
          />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              id="limit-user-agent"
              fullWidth
              label="User Agent"
              value={userAgent}
              variant="filled"
            >
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              disabled
              id="limit-direction"
              select
              fullWidth
              label="File Direction"
              value={fileDirection}
            >
              {fileDirections.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="limit-bucket"
              fullWidth
              label="Bucket Name"
              value={bucketName}
              onChange={handleBucketName}
            >
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="limit-ip"
              fullWidth
              label="Limit IP"
              value={limitIP}
              onChange={handleLimitIP}
            >
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="limit-prefix"
              fullWidth
              label="File Prefix"
              value={filePrefix}
              onChange={handleFilePrefix}
            >
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              id="limit-trigger"
              fullWidth
              label="Trigger Function"
              value={trigger}
            >
            </TextField>
          </Grid>
          </Grid>
          <Grid container spacing={gridSpacing} justifyContent="flex-end">
          <Grid item>
          <button style={styleButton} onClick={handleEditUser}>Send</button>
          </Grid>
          </Grid>
          </Box>
      </MainCard>
    );
};

export default ModifyFileLimitForm;
